/*
 * @Author: liyxt
 * @Date: 2020-02-20 16:01:55
 * @LastEditors: liyxt
 * @LastEditTime: 2020-02-24 10:19:53
 * @Description: file content
 */
import React, { Component } from 'react';
import { Element as ScrollElement, Link } from 'react-scroll';

export { ScrollElement };

export class ScrollLink extends Component {
    render() {
        return <Link {...this.props} />;
    }
}